import Axios from 'axios';
import AxiosConfig from 'src/utilities/AxiosConfig';
import type { SaveApiRequest, DispatchAssignment, ErrorApiResponse, DispatchServiceArea, saveApiResponse, deleteApiResponse, DispatchAssignmentEmployee } from '../types/assignment.types';

export const AssignmentAPI = {
    getErrorMessage: (error: any): string => {
        if (error && typeof error === 'object' && 'response' in error) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx (https://axios-http.com/docs/handling_errors)

            return `${(error.response?.data as any)?.ErrorMessage}`;
        } 
        
        if (error && typeof error === 'object' && 'request' in error) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser (https://axios-http.com/docs/handling_errors)

            return 'Network error: No response from server';
        }

        return 'Unexpected error occurred';
    },

    getDispatchAssignments: async (startDateUtc: string, endDateUtc: string, serviceAreaId: string): Promise<DispatchAssignment[]> => {  
        try {
            const response = await Axios.get(
                `${process.env.REACT_APP_API_URL}/api/portal-dispatch/assignments?startDateTimeUtc=${startDateUtc}&endDateTimeUtc=${endDateUtc}&serviceAreaId=${serviceAreaId}`,
                AxiosConfig.configValue());

            return response.data.Data;
        } catch (error: unknown) {
            const message = AssignmentAPI.getErrorMessage(error);
            throw new Error(message);
        } 
    },

    saveDispatchAssignments: async (dispatchAssignments: SaveApiRequest[]) => {
        try {
            await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/portal-dispatch/save-assignments`,
                dispatchAssignments,
                AxiosConfig.configValue("min"));            
        } catch (error: unknown) {
            const message = AssignmentAPI.getErrorMessage(error);
            throw new Error(message);
        }
    },

    deleteDispatchAssignments: async (dispatchAssignmentIds: number[]) => {
        try {
            await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/portal-dispatch/delete-assignments`,
                dispatchAssignmentIds, 
                AxiosConfig.configValue("min"));
        } catch (error: unknown) {
            const message = AssignmentAPI.getErrorMessage(error);
            throw new Error(message);
        }
    },

    getDispatchServiceAreas: async (): Promise<DispatchServiceArea[]> => {
        try {
            const response = await Axios.get(`${process.env.REACT_APP_API_URL}/api/portal-dispatch/service-areas`, AxiosConfig.configValue());
            return response.data.Data;
        } catch (error: unknown) {
            const message = AssignmentAPI.getErrorMessage(error);
            throw new Error(message);
        }
    },

    getDispatchAssignmentEmployees: async (): Promise<DispatchAssignmentEmployee[]> => {
        try {
            const response = await Axios.get(`${process.env.REACT_APP_API_URL}/api/portal-dispatch/employees`, AxiosConfig.configValue());
            return response.data.Data;
        } catch (error: unknown) {
            const message = AssignmentAPI.getErrorMessage(error);
            throw new Error(message);
        }
    }
}